<template>
  <a-layout>
    <a-space style="margin-top: 2px">
      <vxe-input v-model="query['plan_code']" placeholder="business.label.printNo" size="small" @search-click="getData"/>
      <vxe-button content="button.refresh" icon="vxe-icon-refresh" size="mini" status="primary" @click="getData"/>
      <vxe-button content="button.editPrintTemplate" size="mini" status="primary" @click="edit"/>
      <vxe-button content="button.savePrintTemplate" size="mini" status="primary" @click="save"/>
    </a-space>
    <vxe-table
      border
      stripe
      round
      show-overflow
      show-header-overflow
      :export-config="{}"
      ref="table"
      align="center"
      :data="data"
      :loading="loading"
      :keyboard-config="{isArrow: true}"
      :scroll-x="{enabled: true}"
      :height="scrollY"
      size="mini"
      :row-config="{isCurrent: true, isHover: true}"
      :column-config="{resizable: true}"
      :radio-config="{trigger: 'row'}"
      keep-source
      :edit-config="editConfig"
      style="margin-top: 2px">
      <vxe-column fixed="left" type="seq" width="40"/>
      <vxe-column title="business.label.printNo" field="plan_code"/>
      <vxe-column title="business.label.warehouseId" field="wh_id"/>
      <vxe-column :edit-render="{name: '$select', options: printerData}" field="printer_name" title="business.label.printer"/>
      <vxe-column title="business.label.printTemplate" field="template_name"/>
      <vxe-column title="business.label.templatePath" field="template_path"/>
    </vxe-table>
  </a-layout>
</template>

<script>
import { getPrintClientService, postPrintClientService } from '@/api/Api'
import Vue from 'vue'
import { SCREEN_HEIGHT, WAREHOUSE } from '@/store/mutation-types'
import api from '@/api'

export default {
  name: 'PrintTable',
  data() {
    return {
      warehouse: Vue.ls.get(WAREHOUSE),
      loading: false,
      data: [],
      query: { plan_code: '' },
      printerData: [],
      scrollY: Vue.ls.get(SCREEN_HEIGHT) * (0.85),// 表格竖向滚动条
      editConfig: { trigger: 'click', mode: 'cell', showStatus: true }
    }
  },
  created() {
    getPrintClientService(api.getPrintList).then(res => {
      if (res.success) {
        this.printerData = res.result.map(item => {
          return { label: item, value: item }
        })
      }
    })
    this.getData()
  },
  methods: {
    edit() {
      postPrintClientService(api.editTemplate, {}, this.$refs.table.getRadioRecord()).then(res => {
        if (res.success) {
          this.$success(
            {
              title: '编辑成功',
              centered: true,
              okText:'确定'
            }
          )
        }
      })
    },
    filterData() {
      this.loading = true
      if (this.query['plan_code'] !== '' && this.query['plan_code'] !== null && this.query['plan_code'] !== undefined) {
        this.data = this.data.filter(item => item['plan_code'].includes(this.query['plan_code']))
      }
      this.loading = false
    },
    getData() {
      this.loading = true
      getPrintClientService(api.getPrintPlanMapperList).then(res => {
        if (res.success) {
          console.log("res",res)
          this.data = res.result
          this.filterData()
        } else {
          this.$error(
            {
              title: '无法访问打印客户端',
              content: '请确认打印客户端是否已打开',
              centered: true
            }
          )
        }
      }).finally(() => {
        this.loading = false
      })
    },
    async save() {
      const errMap = await this.$refs.table.validate(true)
      if (errMap) {
        return
      }
      let editData = this.$refs.table.getUpdateRecords()
      if (editData.length > 0) {
        this.loading = true
        postPrintClientService(api.savePrintPlanMapper, {}, { printPlanMapperList: editData }).then(res => {
          if (res.success) {
            this.getData()
            this.$success(
              {
                title: '保存成功',
                centered: true,
                okText: '确定'
              }
            )
          }
        }).finally(() => {
          this.loading = false
        })
      } else {
        this.loading = false
        this.$message.warning('无数据可保存')
      }
    },
    clear() {
      this.query['plan_code'] = ''
    },
    uploadTemplate() {

    }
  }
}
</script>
<style scoped>
</style>